import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { Type } from "class-transformer";

export class ValuationHasProjectDto extends BaseEntityDto {
  @Type(() => ProjectDto)
  project: ProjectDto;
  projectId: string;

  valuationId: string;
}
